import { CredentialWithVerification } from 'types';
import { BaseNimbleAPI } from './baseAPI';

class CredentialsAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/credentials' };
  }

  async getCredentials(candidateId: number): Promise<CredentialWithVerification[]> {
    const response = await this.get('/', {
      params: { candidate_id: candidateId },
    });
    return response.data;
  }
}

export default new CredentialsAPI();
